import React from 'react';
import { useSelector } from 'react-redux';
import { Text, TextProps } from 'evergreen-ui';
import { stationDatasourceIdsLengthSelector } from 'Features/App/Dictionaries/selectors';
import { filterStationDatasourcesIdsByStatusesLengthSelector } from './selectors';

export function DatasourcesFoundCount({ stationId, ...props }:TextProps & {stationId: number}) {
  const allLength = useSelector(stationDatasourceIdsLengthSelector(stationId));
  // undefined значит, что все источники есть
  const filteredLength = useSelector(filterStationDatasourcesIdsByStatusesLengthSelector(stationId));

  return (
    <Text {...props}>{`Источники: ${filteredLength ?? allLength} из ${allLength}`}</Text>
  );
}
export const MemoDatasourcesFoundCount = React.memo(DatasourcesFoundCount);
MemoDatasourcesFoundCount.displayName = 'MemoDatasourcesFoundCount';
export default DatasourcesFoundCount;
